module.exports = __webpack_public_path__ + "static/instagram-215fdb96391ed2ab6636c3718d8246f2.jpg";